
(function(){
  function init(){
    var row=document.getElementById('vidRow'); if(!row) return;
    var prev=document.getElementById('vidRowPrev'), next=document.getElementById('vidRowNext');
    var videos=[].slice.call(row.querySelectorAll('video'));

    // stable snap points so arrows always land exactly on a video, never a blank gap
    row.style.scrollSnapType='x mandatory';
    videos.forEach(function(v){ v.style.scrollSnapAlign='start'; });

    var targetLeft=null, settleTimer=null;
    function clamp(x){ return Math.max(0, Math.min(x, row.scrollWidth-row.clientWidth)); }
    function goTo(x){
      targetLeft=clamp(x);
      row.scrollTo({left:targetLeft,behavior:'smooth'});
    }
    function currentIndex(){
      var best=0,bestDist=Infinity;
      videos.forEach(function(v,i){
        var d=Math.abs(v.offsetLeft-row.scrollLeft);
        if(d<bestDist){bestDist=d;best=i;}
      });
      return best;
    }
    function step(dir){
      var base = targetLeft!==null ? targetLeft : row.scrollLeft;
      var i = clampIndexFromLeft(base);
      var ni = Math.max(0, Math.min(videos.length-1, i+dir));
      goTo(videos[ni].offsetLeft);
    }
    function clampIndexFromLeft(left){
      var best=0,bestDist=Infinity;
      videos.forEach(function(v,i){
        var d=Math.abs(v.offsetLeft-left);
        if(d<bestDist){bestDist=d;best=i;}
      });
      return best;
    }

    if(prev) prev.addEventListener('click',function(){ step(-1); });
    if(next) next.addEventListener('click',function(){ step(1); });

    // only the video mostly in view plays; others pause, so we never overload decode on mobile
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting && e.intersectionRatio>0.6){ e.target.play().catch(function(){}); }
          else { e.target.pause(); }
        });
      }, {root:row, threshold:[0,0.6,1]});
      videos.forEach(function(v){ io.observe(v); });
    }
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
